import Vue from "vue";
import { State, Action } from "vuex-class";
import axios from "axios";
import { API_BASE_URL } from "@/utils/conf";
import GhBase from "@/components/ghBase";
import { RouteConfig } from "vue-router";
import { Mixins, Component } from "vue-property-decorator";
import GhClassService from "@/utils/mixins/clsService";
import { MethodService } from "@/utils/serviceModel";
import { VNode } from "vue";
import codeComponent from "@/components/codeComponent.vue";

@Component({
    components: {
        codeComponent
    }
})
export default class ModuleService extends GhBase {
    @State(state => state.sourceTimestamp)
    public timestamp: { [key: string]: number };

    public async loadPages(rs: RouteConfig, ids: string[], pages: IndexObject, children: RouteConfig[] = []) {
        children = children.length === 0 ? [
            {
                name: "column",
                path: "/portal/column",
                component: () => import("@/portal/table/column/column")
            },
            {
                name: "/portal/menu/config",
                path: "/portal/menu/config",
                component: () => import("@/portal/menu/config/config")
            }
        ] : children;
        let res = await this.getpagesCode.invokeAsyn({ ids });
        if (res.data.isSuccess) {
            let codes: IndexObject = res.data.data;
            for (const id in codes) {
                if (codes.hasOwnProperty(id)) {
                    const code = codes[id];
                    if (code) {
                        let menu: IndexObject = pages[id];
                        let name = menu.PageName ? menu.PageName : menu.Cd;
                        let path = menu.Path ? menu.Path : "/" + menu.Cd;
                        try {
                            let r: RouteConfig = { name, path };
                            if (!menu.IsTemplate) {
                                let component = this.resolveCode(code);
                                r = {
                                    name,
                                    path,
                                    component
                                };
                            }
                            else {
                                let temp = this.getTemplateData(code);
                                let comp = this.resovleTemplate();
                                r = {
                                    name,
                                    path,
                                    component: comp,
                                    props: temp
                                };
                            }
                            children.push(r);
                            let ver = this.timestamp[id];
                            if (ver) {
                                let obj = { ver, code };
                                localStorage.setItem(id, JSON.stringify(obj));
                            }
                        } catch (error) {
                            continue;
                        }
                    }
                }
            }
        }
        rs.children = children;
        this.$router.addRoutes([rs]);
    }

    public resolveCode(code: string) {
        let com: IndexObject = {};
        eval(code);
        @Component(com)
        class X extends Mixins(GhClassService) { }
        return X;
    }

    public resovleTemplate() {
        return Vue.extend(codeComponent);
    }

    public getTemplateData(code: string) {
        if (code) {
            let data = JSON.parse(code);
            return data;
        }
    }

    public async loadAsyncComponents() {
        await this.svGetCodes.invokeAsyn();
        if (this.svGetCodes.isSuccess) {
            let coms = this.svGetCodes.data as IndexObject[];
            coms.forEach(obj => {
                try {
                    let name = obj.Cd;
                    let code = obj.Code;
                    let com = {};
                    eval(code);
                    Vue.component(name, com);
                } catch (error) {
                    console.log(error);
                }
            });
        }
    }

    private getpagesCode: MethodService = new MethodService(
        "plat.page",
        "PageCodeService",
        "get_many_page_code"
    );

    private svGetCodes: MethodService = new MethodService(
        "plat.component",
        "ComponentModel",
        "get_codes"
    );
}
